import { render, staticRenderFns } from "./roleAdminSun.vue?vue&type=template&id=7b9d1be0&scoped=true"
import script from "./roleAdminSun.vue?vue&type=script&lang=js"
export * from "./roleAdminSun.vue?vue&type=script&lang=js"
import style0 from "./roleAdminSun.vue?vue&type=style&index=0&id=7b9d1be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9d1be0",
  null
  
)

export default component.exports